import { MdEmail, MdQrCode2, MdSms } from "react-icons/md";

export const isQrDelivery = (method) => method === "qr_code" || method === "qr_link";

/**
 * Display metadata for a campaign delivery method.
 * `accent` is a StatCard accent name, reused for the list row icon tint.
 */
export const getDeliveryMeta = (method) => {
  if (isQrDelivery(method)) {
    return { label: "QR Code", icon: MdQrCode2, accent: "slate", isQr: true };
  }
  if (method === "sms") {
    return { label: "SMS", icon: MdSms, accent: "sky", isQr: false };
  }
  if (method === "both") {
    return { label: "Email + SMS", icon: MdEmail, accent: "sage", isQr: false };
  }
  return { label: "Email", icon: MdEmail, accent: "sage", isQr: false };
};
